export default {
  middleware_url: "https://gmlog.fluid-it.fr",
  cake_url: "https://gmlog.cake.fluid-it.fr",
  pwa_url: "https://app.gmlog.fluid-it.fr",
  isWavesoftEnabled: false,
  isUrbantzEnabled: false,
  billingConforamaEnabled: false,
  showLockBillingButton: true,
  useRatingSystem: true,
  useMapPage: true,
  useGpsTracking: true,
  instancePrefix: "36",
  ecolixReceptionBetaEnabled: true,
  depotCollectionEnabled: true,
  googleMap: {
    api: "AIzaSyAkhzFFaoDiCIM8_mkKMZFeZnnF9yeKaNA",
  },
};
